import type { PoActivityEvent } from '@/types/poActivity';
import { describeEvent } from '@/utils/poActivity';
import { fmtDate } from '@/utils/poTracker';
import { trackerSentence } from '@/utils/trackerEventSentence';

const LOCALE = 'en-US';
const MS_PER_DAY = 86_400_000;

const lowercaseFirst = (text: string): string => text.charAt(0).toLowerCase() + text.slice(1);

// The line after the actor's name ("Li planned 1,500 pcs…"): tracker sentences start with a capitalised verb,
// board sentences already with a lowercase one.
export function describeTrackerEvent(e: PoActivityEvent): string {
  const sentence = trackerSentence(e);
  if (sentence !== null) return lowercaseFirst(sentence);
  const { verb, where } = describeEvent(e);
  return where ? `${verb} ${where}` : verb;
}

// The calendar day of an instant in a time zone, as YYYY-MM-DD (en-CA formats that way).
function dayKey(date: Date, timeZone: string | undefined): string {
  return new Intl.DateTimeFormat('en-CA', { timeZone, year: 'numeric', month: '2-digit', day: '2-digit' }).format(date);
}

// timeZone defaults to the viewer's own: "today" is their day.
export function relativeWhen(iso: string, now: Date, timeZone?: string): string {
  const at = new Date(iso);
  const day = dayKey(at, timeZone);
  if (day === dayKey(now, timeZone)) {
    return `today ${at.toLocaleTimeString(LOCALE, { hour: '2-digit', minute: '2-digit', hour12: false, timeZone })}`;
  }
  if (day === dayKey(new Date(now.getTime() - MS_PER_DAY), timeZone)) return 'yesterday';
  return fmtDate(day);
}

export function updatesHeading(count: number, vendorName: string, seenAt: string, now: Date, timeZone?: string): string {
  return `${count} ${count === 1 ? 'update' : 'updates'} from ${vendorName} since ${relativeWhen(seenAt, now, timeZone)}`;
}
